(ns hypnos.sleeplab.core.auth
  "Function for authentication & authorization."
  (:require [clojure.string :as str]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; API

(defn therapist-user?
  "Returns true is the current user is a therapist/agent"
  [{:keys [_user groups] :as _auth}]
  (some #(str/starts-with? % "hypnos-agent-group") groups))

(defn authorized?
  "Checks is the current user has the permission, i.e is authorized to perform the
  associated action."
  [{:keys [_user _groups] :as auth} permission]
  (case permission
    :cancel-consult        (therapist-user? auth)
    :create-new-consult    (therapist-user? auth)
    :edit-patient          (therapist-user? auth)
    :make-recommendation   false
    :select-recommendation (therapist-user? auth)
    :send-message          (therapist-user? auth)
    false))
